module.exports = __webpack_public_path__ + "static/media/reg.2a3f0d33.svg";